<div class="max-[991px]:flex-col flex max-[991px]:items-start min-[991px]:items-stretch justify-start w-full min-h-screen bg-white">
    
    <!-- Right Steps Full Screen -->
    <div class="right-steps w-[562px] min-h-screen bg-[#F6F6F6CC] flex flex-col">
        <!-- Steps Logo -->
        <div class="w-[231px] h-[46px] mt-[60px] ms-[60px] mb-[60px]">
            <img
                class="w-full h-full"
                src="assets/img/glameraTradeMarkLogo2.png"
                alt=""
            />
        </div>

        <!-- Steps -->
        <div class="ms-[108px] mb-[12px]">
            <!-- Basic Details Step -->
            <div class="flex items-center justify-start">
                <div class="w-[64px] h-[64px] flex items-center justify-center rounded-[50px] font-[500] text-[32px] text-[#fff] bg-[#635CA8] me-[9.5px]">
                    1
                </div>
                <div class="text-[30px] text-[#000] font-[400]">
                    {{ 'BASIC_DETAILS' | translate }}
                </div>
            </div>

            <!-- Vertical Line -->
            <div class="ms-[28px] h-[190px] border-s-[8px] border-solid border-[#CCCCCCCC]"
                [ngClass]="{'!border-[#635CA8]': isStepCompleted(0)}"></div>

            <!-- Business Details Step -->
            <div class="flex items-center justify-start">
                <div class="w-[64px] h-[64px] flex items-center justify-center rounded-[50px] font-[500] text-[32px] text-[#000] bg-[#CCCCCC] me-[9.5px]"
                    [ngClass]="{'text-[#fff] !bg-[#635CA8]': isStepCompleted(1) || isStepCompleted(0)}">
                    2
                </div>
                <div class="text-[30px] text-[#000] font-[400]">
                    {{ 'BUSINESS_DETAILS' | translate }}
                </div>
            </div>

            <!-- Vertical Line -->
            <div class="ms-[28px] h-[190px] border-s-[8px] border-solid border-[#CCCCCCCC]"
                [ngClass]="{'!border-[#635CA8]': isStepCompleted(1)}"></div>

            <!-- Working Hours Step -->
            <div class="flex items-center justify-start">
                <div class="w-[64px] h-[64px] flex items-center justify-center rounded-[50px] font-[500] text-[32px] text-[#000] bg-[#CCCCCC] me-[9.5px]"
                    [ngClass]="{'text-[#fff] !bg-[#635CA8]': selectedIndex == 2}">
                    3
                </div>
                <div class="text-[30px] text-[#000] font-[400]">
                    {{ 'WORKING_HOUR' | translate }}
                </div>
            </div>
        </div>
    </div>

    <!-- Right Steps Mobile -->
    <div class="relative block min-[991px]:hidden w-full">
        <!-- Header -->
        <div class="mx-[16px] my-[24px] flex items-center justify-between">
            <!-- Poster Logo -->
            <img
                class="w-[90px] h-[17px]"
                src="assets/img/glameraTradeMarkLogo2.png"
                alt=""
            />

            <!-- Language & Watch Video Button -->
            <app-auto-registration-top-bar
                logoSrc="assets/img/glameraTradeMarkLogo.png"
                [showLogo]="false"
                [darkMode]="false"
                languageColor="#000"
                (watchVideo)="onOpenVideo()"
            ></app-auto-registration-top-bar>
        </div>

        <div class="flex items-center justify-center mt-[24px] mb-[50px]">
            <!-- Basic Details Step -->
            <div class="relative w-[24px] h-[24px] bg-[#635CA8] text-[12px] text-[#fff] font-[500] rounded-[50px] flex items-center justify-center">
                1
                <span class="absolute -bottom-[26px] w-max h-[18px] text-[12px] text-[#000] font-[400]">
                    {{ 'BASIC_DETAILS' | translate }}
                </span>
            </div>

            <!-- Horizontal Line -->
            <div class="h-[2px] w-[106px] bg-[#F5F7FA]"
                [ngClass]="{'!bg-[#635CA8]': isStepCompleted(0)}"></div>

            <!-- Business Details Step -->
            <div class="relative w-[24px] h-[24px] bg-[#CCCCCC] text-[12px] text-[#000] font-[500] rounded-[50px] flex items-center justify-center"
                [ngClass]="{'text-[#fff] !bg-[#635CA8]': isStepCompleted(1) || isStepCompleted(0)}">
                2
                <span class="absolute -bottom-[26px] w-max h-[18px] text-[12px] text-[#000] font-[400]">
                    {{ 'BUSINESS_DETAILS' | translate }}
                </span>
            </div>

            <!-- Horizontal Line -->
            <div class="h-[2px] w-[106px] bg-[#F5F7FA]"
                [ngClass]="{'!bg-[#635CA8]': isStepCompleted(1)}"></div>

            <!-- Working Hours Step -->
            <div class="relative w-[24px] h-[24px] bg-[#CCCCCC] text-[12px] text-[#000] font-[500] rounded-[50px] flex items-center justify-center"
                [ngClass]="{'text-[#fff] !bg-[#635CA8]': selectedIndex == 2}">
                3
                <span class="absolute -bottom-[26px] w-max h-[18px] text-[12px] text-[#000] font-[400]">
                    {{ 'WORKING_HOUR' | translate }}
                </span>
            </div>
        </div>
    </div>

    <!-- Step Part -->
    <div class="px-[16px] min-[991px]:ps-[48px] min-[991px]:pe-[60px] pt-[16px] min-[991px]:pt-[60px] min-[991px]:flex-1 w-full">
        <!-- Language & Watch Video Button -->
        <div class="max-[991px]:hidden flex items-center justify-end mb-[40px]">
            <button class="me-[24px] w-[131px] h-[37px] rounded-[27px] flex items-center justify-center bg-[#635CA8]" 
                type="button" 
                (click)="onOpenVideo()">
                <span class="text-[14px] text-white font-[700] me-[5px]">{{ 'WatchVideo' | translate }}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="16" height="16" rx="8" fill="white"/>
                    <g clip-path="url(#clip0_13621_4345)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.34375C5.98071 4.34375 4.34375 5.98071 4.34375 8C4.34375 10.0193 5.98071 11.6562 8 11.6562C10.0193 11.6562 11.6562 10.0193 11.6562 8C11.6541 5.98159 10.0184 4.34588 8 4.34375ZM8 11.0938C6.29137 11.0938 4.90625 9.70863 4.90625 8C4.90625 6.29137 6.29137 4.90625 8 4.90625C9.70863 4.90625 11.0938 6.29137 11.0938 8C11.0918 9.70783 9.70783 11.0918 8 11.0938ZM9.28109 7.76586L7.59359 6.64086C7.50727 6.58326 7.39624 6.57789 7.30475 6.62687C7.21327 6.67585 7.15618 6.77123 7.15625 6.875V9.125C7.15618 9.22877 7.21327 9.32415 7.30475 9.37313C7.39624 9.42211 7.50727 9.41674 7.59359 9.35914L9.28109 8.23414C9.35945 8.182 9.40652 8.09412 9.40652 8C9.40652 7.90588 9.35945 7.818 9.28109 7.76586ZM7.71875 8.59941V7.40234L8.61805 8L7.71875 8.59941Z" fill="#694ED6"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_13621_4345">
                            <rect width="9" height="9" fill="white" transform="translate(3.5 3.5)"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>
            <lib-language color="#000"></lib-language>
        </div>

        <!-- Current Step Component -->
        <ng-container [ngSwitch]="selectedIndex">
          <app-basic-details-step
            *ngSwitchCase="0"
            (next)="onBasicDetailsNext()"
          ></app-basic-details-step>
          <app-business-details-step
            *ngSwitchCase="1"
            [isFromPrevious]="isBusinessDetailsFromPrevious"
            (next)="onBusinessDetailsNext($event)"
          ></app-business-details-step>
          <app-working-hours-step
            *ngSwitchCase="2"
            (previous)="onWorkingHoursPrevious()"
          ></app-working-hours-step>
        </ng-container>
    </div>
</div>

